import { Component, OnInit } from '@angular/core';
import { AutomationService } from '../automation.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'userinfo-nil-transformation',
    templateUrl: './userinfo-nil-transformation.component.html',
    styleUrls: ['./userinfo-nil-transformation.component.css']
})
export class UserInfoNilTransformation implements OnInit {

    public sheets: any[] = [];

    public password: string = '';

    public errorOverLay;

    public transformedResponse: string;

    public form: FormGroup;

    public somethingToCopy: boolean;

    public lastValidRespone: string;


    constructor(private automationService: AutomationService, private formBuilder: FormBuilder) { }

    public ngOnInit() {
        this.form = new FormGroup({
            'responseInput': new FormControl('', Validators.required),
        });
        if (document.getElementById('transformedResponse')) {
            document.getElementById('transformedResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
        }
        this.form.controls.responseInput.valueChanges.subscribe(() => {
            if (document.getElementById('transformedResponse')) {
                document.getElementById('transformedResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
            }

        })
    }


    public startTransformation() {

        let json;
        let validJson: boolean = false;
        const pre = document.createElement('pre');

        this.somethingToCopy = false;
        pre.style.height = '700px';
        if (document.getElementById('transformedResponse')) {
            document.getElementById('transformedResponse').innerHTML = '';
        }

        try {
            json = JSON.parse(this.form.controls.responseInput.value);
            validJson = true;
        } catch (error) {
            this.errorOverLay = {
                message: 'Invalid JSON Input<br/>' + error,
            };

            if (document.getElementById('transformedResponse')) {
                document.getElementById('transformedResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
            }
        }

        if (validJson) {
            if (json.userAccountVBO || (json.mobileContractArray || json.fixednetContractArray || json.cableContractArray) ||
                (json[0] && json[0].userAssets)) {
                this.automationService.transformJSON(json).subscribe((json) => {
                    const stringifiedJSON = JSON.stringify(json, null, 2);
                    document.getElementById('transformedResponse').appendChild(pre).innerHTML = this.automationService.pretifyJson(stringifiedJSON);
                    this.lastValidRespone = stringifiedJSON;
                    this.somethingToCopy = true;
                }, (error) => {
                    this.errorOverLay = {
                        message: 'Transformation To User Info Failed <br/>' + (error.json ? error.json().message : error),
                    };

                    if (document.getElementById('transformedResponse')) {
                        document.getElementById('transformedResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
                    }
                });
            } else {

                this.errorOverLay = {
                    message: `Invalid NIL Or User Info Input`,
                };

                if (document.getElementById('transformedResponse')) {
                    document.getElementById('transformedResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
                }
            }

        }
    }

    public copyToClipBoard() {

        this.automationService.copyToClipboard(this.lastValidRespone).then(function () {
            console.log('Copying to clipboard was successful!');
        }, function (error) {
            this.errorOverLay = {
                message: 'Cannot Copy To Clip Board <br/>' + error,
            };
        });
    }

    public closeOverLay() {

        this.errorOverLay = null;
    }

    public onPasteNil() {

        setTimeout(() => {
            if (document.getElementById('transformedResponse')) {
                document.getElementById('transformedResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
            }
            document.getElementById("response-input") && document.getElementById("response-input").scroll(0, 0);
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/userinfo-nil-transformation/userinfo-nil-transformation.component.ts